import { render, staticRenderFns } from "./OnboardingAccountCreation.vue?vue&type=template&id=7ffd058c&scoped=true&lang=pug"
import script from "./OnboardingAccountCreation.vue?vue&type=script&lang=ts"
export * from "./OnboardingAccountCreation.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingAccountCreation.vue?vue&type=style&index=0&id=7ffd058c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffd058c",
  null
  
)

export default component.exports